export default __webpack_public_path__ + "static/media/rpl3.43691008.jpg";